<template>     
    <section id="head">
        <div
            data-aos="fade-down"
            data-aos-duration="200"
            data-aos-delay="100"
            data-aos-easing="ease-in-out"
            data-aos-anchor-placement="top-center"
        >

            <div class="logo">
                <b>Blockchain</b>
                <span>Venture Capital</span>
            </div>
            <div class="lang">
                    <span class="lg"><i class="iconfont icon-shixindiqiu"></i><Lang/></span>
                    <Poptip placement="bottom-end" class="pop-menu" :offset="20">
                        <i class="iconfont icon-caidan"></i> 
                        <div slot="content">
                            <Menu/>
                        </div>                            
                    </Poptip>
            </div>
        </div>
    </section>
</template>

<script>
import {mapState} from "vuex"
import Menu from '../components/menu'
import Lang from '../components/changeLang'
import {Poptip}  from 'iview'
export default {
    components:{
        Menu,Lang,Poptip
    },
    data () {
        return{
        }
    },
    computed:
        mapState(['lang','local','skin'])
    ,
    created(){
        
    },
    mounted () {

    },
    methods:{

    }
    // render (h) {
    //     return (
    //     )
    // }
}
</script>

<style lang="less" scoped>
    #head{
        max-width: 1100px;
        height: 85px;
        background:#fff;
        border-radius:0 0 4px 4px;
        margin:0 auto;
        padding:15px 20px;
        .logo{
            float: left;
            background: url("../assets/images/logo.png") no-repeat;
            padding-left:70px;
            width:185px;
            height:60px;
            b{display:block;font-size:20px;color:#912121;margin-top:13px;line-height: 18px;}
            span{color: #431717;font-size:14px;line-height: 16px;}
        }
        .lang{
            float: right;
            text-align: center;
            margin-top:10px;
            i{font-size:20px;color:#aaa}
            .icon-caidan{
                color:#FFB5B4;
                cursor: pointer;
                font-size: 30px;
                position: relative;
                top:3px;
            }
            .lg{
                margin-right:10px;
                padding-right: 10px;
                border-right: 1px dotted #aaa;
                height:20px;
                line-height: 20px;
                display: inline-block;
            }            
        }
    }
    
</style>

